import { digitalSuiteAdvertiserActivityNavBarContent } from "app/components/sidebar3/secondary-side-bar/secondary-bar-nav-obj/ad-intelligence/advertiserActivityNavObj";
import type { ISecondaryBarContents } from "app/components/sidebar3/secondary-side-bar/types/ISecondaryBarContents";

import { SI_AA_ROUTES, SI_DISPLAY_ROUTES, SI_LLMS_ROUTES, SI_SEARCH_ROUTES, SI_SOCIAL_ROUTES } from "./constants";

/**
 * SI variant of the Advertiser Activity secondary sidebar.
 * Every navigation target is rebound to an SI-owned state — users never escape to WI
 * via the sidebar. Internal in-page navigations that still target WI states are rewritten
 * to their SI mirrors by the `onBefore` hook in {@link app/pages/sales-intelligence/utils/redirectWiToSi}.
 */
export const salesAdvertiserActivityNavBarContent = (): ISecondaryBarContents =>
    digitalSuiteAdvertiserActivityNavBarContent({
        homeState: SI_AA_ROUTES.home,
        routeOverrides: {
            overview: SI_AA_ROUTES.overview,
            display: {
                overview: SI_DISPLAY_ROUTES.overview,
                campaigns: SI_DISPLAY_ROUTES.campaigns,
                ads: SI_DISPLAY_ROUTES.ads,
                publishers: SI_DISPLAY_ROUTES.publishers,
            },
            search: {
                monitorKeywordsHome: SI_SEARCH_ROUTES.monitorKeywordsHome,
                monitorKeywords: SI_SEARCH_ROUTES.monitorKeywords,
                keywordLandingPages: SI_SEARCH_ROUTES.keywordLandingPages,
                serpPlayers: SI_SEARCH_ROUTES.serpPlayers,
                keywordAds: SI_SEARCH_ROUTES.keywordAds,
                topics: SI_SEARCH_ROUTES.topics,
                keywords: SI_SEARCH_ROUTES.keywords,
                landingPages: SI_SEARCH_ROUTES.landingPages,
                textAndShoppingAds: SI_SEARCH_ROUTES.textAndShoppingAds,
            },
            social: {
                ads: SI_SOCIAL_ROUTES.ads,
            },
            // Sales Intelligence has no AI ads gallery of its own — its AI item keeps pointing at
            // the promo page.
            ai: {
                ads: SI_LLMS_ROUTES.promo,
            },
        },
    });
